module.exports = __webpack_public_path__ + "img/running-profile.f2b89c9a.svg";